import { mainApi } from "../services/main/api";

const extendedApi = mainApi.injectEndpoints({
    endpoints: builder => ({
        updateExpandedComps: builder.mutation<
            UpdateExpandedCompsResponse,
            UpdateExpandedCompsRequest
        >({
            query: (request: UpdateExpandedCompsRequest) => ({
                url: "updateExpandedComps",
                body: request,
                method: "POST",
            }),
        }),
    }),
    overrideExisting: true,
});

export const { useUpdateExpandedCompsMutation } = extendedApi;

export interface UpdateExpandedCompsRequest {
    businessUseCase: string;
    appealArtifactId: string;
    expandedCompsDetails: ExpandedComp[];
    approachType: string;
    subjectIdentifier: string;
}

export interface UpdateExpandedCompsResponse {
    status: string;
    message?: string;
}

export interface ExpandedComp {
    zip: number;
    address: string;
    city: string;
    buildingSize: number;
    averageStoryHeight: number;
    salePrice: number;
    saleType: string;
    uiEnabled: boolean;
    county: string;
    saleDate: string;
    propertyClass: string;
    yearBuilt: number;
    pdfPageS3Keys: string[];
    recordId: string;
    parcelNumber: string;
    landToBuildingRatio: number;
    condition: string;
    landSize: number;
    distanceFromSource: number;
    enable: boolean;
    propertyType: string;
    financing: string;
    state: string;
    pricePerSq: number;
}
